import React, { useEffect, useState } from 'react';
import { Form, Input, Layout, message, Select } from 'antd';

import PdButton from 'components/pd-button';
import PdUploader from 'components/pd-uploader';

import BrandApi from 'services/brand';
import { errHandling } from 'utils';

import 'react-quill-new/dist/quill.snow.css';
import './style.scss';
import { useNavigate, useLocation } from 'react-router-dom';

const { Content } = Layout;
const { Option } = Select;

const FIELDS = {
  BRAND_CATEGORIES: 'brand_categories_attributes',
  CATEGORIES: 'categories',
  DESKTOP_MEDIA_URL: 'image_url',
  MOBILE_MEDIA_URL: 'mobile_image',
  TITLE: 'title',
};

export function BrandCreateEdit() {
  const navigate = useNavigate();
  const location = useLocation();
  const [form] = Form.useForm();
  const [category, setCategory] = useState([]);
  const [loadingButton, setLoadingButton] = useState(false);
  const [desktopImageUrl, setDesktopImageUrl] = useState('');

  const urlParams = new URLSearchParams(location.search);
  const id = urlParams.get('id');

  async function getCategoryList() {
    try {
      const { data } = await BrandApi.getCategoryList();
      setCategory(data.data);
    } catch (err) {
      errHandling(err);
    }
  }

  async function loadBrandData(brandId) {
    try {
      const { data } = await BrandApi.showBrand(brandId);
      const brand = data.data;

      form.setFieldsValue({
        [FIELDS.TITLE]: brand.title,
        [FIELDS.BRAND_CATEGORIES]: brand.categories?.map((c) => c.id) || [],
        [FIELDS.DESKTOP_MEDIA_URL]: brand.image_url,
      });
      setDesktopImageUrl(brand.image_url);
    } catch (error) {
      errHandling(error);
    }
  }

  function handleImageUpload(url) {
    setDesktopImageUrl(url);
  }

  async function handleSubmit(values) {
    try {
      setLoadingButton(true);

      const payload = {
        ...values,
        [FIELDS.BRAND_CATEGORIES]: (values[FIELDS.BRAND_CATEGORIES] || []).map((categoryId) => ({
          category_id: categoryId,
        })),
        [FIELDS.DESKTOP_MEDIA_URL]: desktopImageUrl,
      };

      if (id) {
        await BrandApi.updateBrand({...payload, id});
        message.success('Successfully updated brand');
      } else {
        await BrandApi.createBrand(payload);
        message.success('Successfully created brand');
      }

      navigate('/brands');
    } catch (err) {
      const errMessage = err?.response?.data?.message || '';
      message.error(errMessage || 'Cannot connect to server, please check connection');
    } finally {
      setLoadingButton(false);
    }
  }

  useEffect(() => {
    getCategoryList();
    if (id) {
      loadBrandData(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <Layout className="pd-cms-brand main-container">
      <div className="container">
        <div className="content">
          <div className="pageTitle">{id ? 'Edit' : 'Create New'} Brand</div>
          <Content className="pageContent">
            <Form
              form={form}
              layout="vertical"
              onFinish={handleSubmit}>
              <div className="section-container">
                <div className="inner-section">
                  <Form.Item
                    label="Title"
                    name={FIELDS.TITLE}
                    rules={[{ message: 'Please input Title!', required: true }]}>
                    <Input placeholder="Write brand name here" />
                  </Form.Item>

                  <Form.Item
                    label="Category"
                    name={FIELDS.BRAND_CATEGORIES}
                    rules={[{ message: 'Please input category!', required: true }]}>
                    <Select
                      className="w-full"
                      mode="multiple"
                      placeholder="Please select"
                      filterOption={(input, option) =>
                        option?.children?.toLowerCase()?.includes(input?.toLowerCase())
                      }>
                      {category.map((cate) => (
                        <Option key={cate.id} value={cate.id}>
                          {cate.title}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <Form.Item label="Picture">
                    <PdUploader
                      afterUpload={handleImageUpload}
                      imgClassName="w-30"
                      imgUrl={desktopImageUrl}
                      keyValue={FIELDS.DESKTOP_MEDIA_URL}
                      name="Picture"
                    />
                  </Form.Item>
                </div>

                <Form.Item>
                  <div className="buttonSection mt-40">
                    <PdButton
                      full
                      htmlType="submit"
                      loading={loadingButton}
                      type="primary">
                      Publish
                    </PdButton>
                  </div>
                </Form.Item>
              </div>
            </Form>
          </Content>
        </div>
      </div>
    </Layout>
  );
}

export default BrandCreateEdit;
